import { __assign, __extends } from "tslib";
/* I50 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Message = /** @class */ (function (_super) {
    __extends(Message, _super);
    function Message() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Message.prototype.render = function () {
        return (React.createElement(IconWrap, __assign({}, this.props),
            React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
                React.createElement("g", null,
                    React.createElement("path", { d: "M19.663 9.291l-7.39 3.646a.617.617 0 0 1-.546 0L4.337 9.47A.6.6 0 0 1 4 8.933V5.602C4 5.269 4.273 5 4.61 5h14.78c.337 0 .61.27.61.602v3.152l-.337.537zm-.46 1.763c.366-.168.797.076.797.45v6.993c0 .278-.247.503-.55.503H4.55c-.303 0-.55-.225-.55-.503v-6.693c0-.366.414-.61.779-.459l6.982 2.902c.151.063.325.06.474-.008l6.968-3.185z" })))));
    };
    return Message;
}(React.Component));
export { Message };
export default Message;
//# sourceMappingURL=Message.js.map